<template>
  <page-layout title="증명서 신청">
    <template v-slot:search>
      <certification-type-list
        @refresh="refreshList"
      />
    </template>
    <template v-slot:table>
      <certification-assign-table
        :data="data"
        :loading="loading"
        @change="changeState"
        @refresh="refreshList"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import CertificateTypeList from "@/pages/Certificate/components/CertificateTypeList.vue";
import CertificateSignupTable from "@/pages/Certificate/components/CertificateSignupTable.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "Certificate",
  components: {CertificationAssignTable: CertificateSignupTable, CertificationTypeList: CertificateTypeList, PageLayout},
  data() {
    return {
      paramsData: {},
      data: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      memberRole: "memberRole"
    }),
    isAdmin() {
      return this.memberRole === "ADMIN";
    }
  },
  mounted() {
    this.getCertificateList({
      memberId: this.isAdmin ? "" : this.memberId,
      state: ""
    });
  },
  methods: {
    async getCertificateList(params) {
      this.paramsData = params;
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/private/certificate/list", { params });
        if (data.length < 1) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    changeState(state) {
      this.paramsData.state = state;
      this.getCertificateList(this.paramsData);
    },
    refreshList() {
      this.getCertificateList(this.paramsData);
    }
  }
}
</script>